import { render, staticRenderFns } from "./expDocsF.vue?vue&type=template&id=e271e174"
import script from "./expDocsF.vue?vue&type=script&lang=js"
export * from "./expDocsF.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports